import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const UtahHousingChart = ({ data }) => {
  const chartsData = data;
  const monthlyKeys = ["02-2025", "02-2026"];

  const parsePrice = (value) => {
    if (!value || value === "--") {
      return null;
    }

    const numericValue = Number(String(value).replace(/[$,]/g, ""));
    return Number.isFinite(numericValue) ? numericValue : null;
  };

  const formatMonthLabel = (key) => {
    const [month, year] = key.split("-");
    const monthLabels = {
      "01": "Jan",
      "02": "Feb",
      "03": "Mar",
      "04": "Apr",
      "05": "May",
      "06": "Jun",
      "07": "Jul",
      "08": "Aug",
      "09": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec",
    };

    return `${monthLabels[month]} ${year}`;
  };

  const changeValue = chartsData?.["Increase/Decrease"];
  const hasMonthlyChange = changeValue && changeValue !== "--";

  if (!chartsData) {
    return "loading...";
  }

  const barData = {
    labels: monthlyKeys.map(formatMonthLabel),
    datasets: [
      {
        label: "Price",
        data: monthlyKeys.map((key) => parsePrice(chartsData[key])),
        // backgroundColor: ["rgba(1, 66, 178, 0.8)", "rgba(203, 12, 12, 0.8)"],
        // borderColor: ["rgba(1, 66, 178, 1)", "rgba(203, 12, 12, 1)"],
        borderWidth: 1,
        barThickness: 50,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: chartsData.Color, // White color for legend text
        },
      },
      title: {
        display: true,
        text: `Median Sales Price Comparison: ${formatMonthLabel(
          monthlyKeys[0]
        )} vs ${formatMonthLabel(monthlyKeys[1])} (Monthly)`,
        color: chartsData.Color,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            if (tooltipItem.raw == null) {
              return "No data";
            }
            return `$${tooltipItem.raw.toLocaleString("en-US")}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Month",
          color: chartsData.Color,
        },
        ticks: {
          color: chartsData.Color, // White color for x-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.2)", // Light white grid lines
        },
      },
      y: {
        title: {
          display: true,
          text: "Price ($)",
          color: chartsData.Color,
        },
        ticks: {
          color: chartsData.Color, // White color for x-axis labels
        },
        grid: {
          color: "rgba(255, 255, 255, 0.2)", // Light white grid lines
        },
        beginAtZero: true,
      },
    },
    animation: {
      duration: 1500,
      easing: "easeInOutBounce",
    },
  };

  const chartStyle = {
    perspective: "1000px",
    transform: "rotateX(-10deg)",
    margin: "20px auto",
    maxWidth: "90%",
    padding: "15px",
  };

  return (
    <div style={chartStyle}>
      <Bar data={barData} options={options} />

      {!hasMonthlyChange ? (
        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            marginTop: "10px",
            color: chartsData.Color,
          }}
        >
          {" "}
          <strong>Change:</strong> --
        </p>
      ) : changeValue[0] === "-" ? (
        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            marginTop: "10px",
            color: "red",
          }}
        >
          {" "}
          <strong>Decrease:</strong> {changeValue}
        </p>
      ) : (
        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            marginTop: "10px",
            color: "green",
          }}
        >
          {" "}
          <strong>Increase:</strong> {changeValue}
        </p>
      )}
    </div>
  );
};

export default UtahHousingChart;
